import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Software } from 'src/app/models/software';
import { StaticDataService } from 'src/app/services/shared/static.data.service';


@Component({
  selector: 'app-software-select',
  templateUrl: './software-select.component.html',
  styleUrls: ['./software-select.component.scss']
})
export class SoftwareSelectComponent implements OnInit {
  softwares: Software[] = [];

  @Input() selectedSoftwareIds: number[] = [];
  @Input() placeholder: string = '';
  @Output() selectedSoftwareChanged: EventEmitter<number[]> = new EventEmitter<number[]>();

  constructor(public staticDataService: StaticDataService) { }

  ngOnInit(): void {
    this.softwares = [...this.staticDataService.softwares];
  }

  public SoftwareSelected() {
    this.selectedSoftwareChanged.emit(this.selectedSoftwareIds);
  }
}
